import React from "react";
import { Button, Checkbox } from "antd";

/**
 * רשימת נוסעים לבחירת כבודה — checkbox לכל נוסע רלוונטי.
 */
export default function PassengerSupplementPicker({
  paxList,
  selectedIds,
  onToggle,
  onRequestClose,
}) {
  return (
    <div className="fb-extra-picker" role="dialog" aria-label="בחירת נוסעים לכבודה">
      <div className="fb-extra-picker__title">בחר נוסעים</div>
      {paxList.map((p) => {
        const checked = selectedIds.includes(p.id);
        return (
          <div key={p.id} className="fb-extra-picker__row">
            <Checkbox
              checked={checked}
              onChange={(e) => onToggle(p.id, e.target.checked)}
            >
              {p.labelHe}
            </Checkbox>
          </div>
        );
      })}
      <Button type="default" block className="fb-extra-picker__close" onClick={onRequestClose}>
        סגור
      </Button>
    </div>
  );
}
